import { render, staticRenderFns } from "./cost-of-deferment-calculator.vue?vue&type=template&id=ef2fb26e&scoped=true&"
import script from "./cost-of-deferment-calculator.vue?vue&type=script&lang=js&"
export * from "./cost-of-deferment-calculator.vue?vue&type=script&lang=js&"
import style0 from "./cost-of-deferment-calculator.vue?vue&type=style&index=0&id=ef2fb26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2fb26e",
  null
  
)

export default component.exports